import { getRequestHeaders, handleRes } from "utils";
import { Ruleset } from "types";

export interface GetRulesetResponse extends Response {
  ruleset?: Ruleset;
}

interface GetRulesetByIDParams {
  tenantID: string | number | undefined;
  rulesetID: string | number | undefined;
}
export const getRulesetByID = async ({
  tenantID,
  rulesetID,
}: GetRulesetByIDParams): Promise<Ruleset> => {
  return fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/rulesets/${rulesetID}`,
    {
      method: "GET",
      ...getRequestHeaders(),
    },
  )
    .then((res) => handleRes<Ruleset>(res, 200))
    .catch((e) => {
      throw e;
    });
};

interface CreateRulesetParams {
  tenantID: string | number | undefined;
  body: string; //Ruleset as JSON string
}
export const createRuleset = async ({
  tenantID,
  body,
}: CreateRulesetParams): Promise<GetRulesetResponse> => {
  return await fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/rulesets`,
    {
      method: "POST",
      ...getRequestHeaders(),
      body,
    },
  );
};

interface UpdateRulesetParams {
  rulesetID: string | number | undefined;
  tenantID: string | number | undefined;
  body: string; //Ruleset as JSON string
}
export const updateRuleset = async ({
  rulesetID,
  tenantID,
  body,
}: UpdateRulesetParams): Promise<GetRulesetResponse> => {
  return await fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/rulesets/${rulesetID}`,
    {
      method: "PUT",
      ...getRequestHeaders(),
      body,
    },
  );
};

export const getTenantRulesets = (tenantID: number): Promise<Ruleset[]> => {
  return fetch(`${window.PROPERTY_BASE_URL}/tenant/${tenantID}/rulesets`, {
    method: "GET",
    ...getRequestHeaders(),
  })
    .then((res) => handleRes<Ruleset[]>(res, 200))
    .catch((e) => {
      throw e;
    });
};

interface PutPropertyRulesetsParams {
  tenantID: string | number | undefined;
  propertyID: string | number | undefined;
  body: string; // Ruleset[] as JSON string
}
export const putPropertyRulesets = async ({
  tenantID,
  propertyID,
  body,
}: PutPropertyRulesetsParams): Promise<Response> => {
  return await fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/properties/${propertyID}/rulesets`,
    {
      method: "PUT",
      ...getRequestHeaders(),
      body,
    },
  );
};

interface PutPropertyGroupRulesetsParams {
  tenantID: string | number | undefined;
  groupID: string | number | undefined;
  body: string; // Ruleset[] as JSON string
}
export const putPropertyGroupRulesets = async ({
  tenantID,
  groupID,
  body,
}: PutPropertyGroupRulesetsParams): Promise<Response> => {
  return await fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/propertyGroups/${groupID}/rulesets`,
    {
      method: "PUT",
      ...getRequestHeaders(),
      body,
    },
  );
};

interface GetPropertyPropertyGroupRulesetsParams {
  tenantID: string | number | undefined;
  propertyID: string | number | undefined;
}
export const getPropertyPropertyGroupRulesets = ({
  tenantID,
  propertyID,
}: GetPropertyPropertyGroupRulesetsParams): Promise<Ruleset[]> => {
  return fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/properties/${propertyID}/propertyGroups/rulesets`,
    {
      method: "GET",
      ...getRequestHeaders(),
    },
  )
    .then((res) => handleRes<Ruleset[]>(res, 200))
    .catch((e) => {
      throw e;
    });
};
